import { EAvailableLanguages } from '@/configuration/lang/types';
import { chatApi } from '@/services/chatApi/chatApi';
import { EResponseStatus } from '@/services/config/types';
import { addMessage } from '@/store/chat/chat.slice';
import { setScrollPosition } from '@/store/sidebar/sidebarSlice';
import { selectActiveThreadId, selectThreadById, updateThread } from '@/store/thread/threadSlice';

import { startAppListening } from '../middleware/listenerMiddleware';

// INFO: Injects an AI error message into the chat store when the server responds with a 200 HTTP code but a failure status.
startAppListening({
  matcher: chatApi.endpoints.sendMessage.matchFulfilled,
  effect: (action, { dispatch, getState }) => {
    const data = action.payload;

    if (data.status !== EResponseStatus.ERROR) return;

    const activeThreadId = selectActiveThreadId(getState());

    dispatch(
      addMessage({
        messageId: '',
        content: data.serverMessage,
        role: 'ai',
        threadId: activeThreadId,
        timestamp: new Date().toISOString(),
        isOnboardingQuestion: false,
        data_visualization: {
          default_data_visualization: null,
          x_axis: null,
        },
        // INFO: The message language here is not known by the client, it is also irrelevant therefore it defaults to english
        language: EAvailableLanguages.EN,
      }),
    );
  },
});

// INFO: Reorders the thread list by updating the thread timestamp and resetting the sidebar scroll position after a successful message send.
startAppListening({
  matcher: chatApi.endpoints.sendMessage.matchFulfilled,
  effect: (action, { dispatch, getState }) => {
    const data = action.payload;

    if (data.status === EResponseStatus.ERROR) return;

    if (data.threadId) {
      const thread = selectThreadById(getState(), data.threadId);
      if (thread) {
        dispatch(
          updateThread({
            threadId: data.threadId,
            updatedThread: { timestamp: new Date().toISOString() },
          }),
        );
      }
    }

    dispatch(setScrollPosition(0));
  },
});
